module.exports = __webpack_public_path__ + "media/application/images/svgs/chevron-thin-71e72f88a9b2795a3d909defbcb6004f.svg";